export default __webpack_public_path__ + "static/media/tools.7bedc822.svg";